import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { environment } from './core/helpers/environment'

if (environment.isProd) {
  // Include your iframe script here if production
  const script = document.createElement('script')
  script.src = '//s00.static-shell.com/apps/shell-common/components/components/iframe/clientlib/external.min.js'
  document.head.appendChild(script)
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
